export default __webpack_public_path__ + "8d72bdcfecf29eb924e69d0dbedcd177.jpg";